(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["audience-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    const STORAGE_KEY = 'bondit_audience';
    const DEFAULT_AUDIENCE = window.themeSettings?.defaultAudience || 'trade';

    function getAudience() {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT_AUDIENCE;
    }

    function setAudience(audience) {
      localStorage.setItem(STORAGE_KEY, audience);
      document.documentElement.dataset.audience = audience;
      updateSwitchers(audience);
      updateSectionVisibility(audience);

      // Dispatch custom event for other components to react to audience changes
      document.dispatchEvent(
        new CustomEvent('audience:changed', {
          detail: { audience },
        })
      );
    }

    function updateSwitchers(audience) {
      document.querySelectorAll('[data-audience-switcher]').forEach((switcher) => {
        switcher.querySelectorAll('[data-audience]').forEach((btn) => {
          btn.setAttribute('aria-pressed', btn.dataset.audience === audience);
        });
      });
    }

    function updateSectionVisibility(audience) {
      document.querySelectorAll('[data-section-visibility]').forEach((section) => {
        const visibility = section.dataset.sectionVisibility;
        if (visibility === 'both') {
          section.style.display = '';
        } else if (visibility === audience) {
          section.style.display = '';
        } else {
          section.style.display = 'none';
        }
      });
    }

    function init() {
      if (window.themeSettings?.customerLoggedIn) {
        setAudience('trade');
        return;
      }

      const audience = getAudience();
      document.documentElement.dataset.audience = audience;
      updateSwitchers(audience);
      updateSectionVisibility(audience);

      document.querySelectorAll('[data-audience-switcher] [data-audience]').forEach((btn) => {
        btn.addEventListener('click', () => {
          setAudience(btn.dataset.audience);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Expose for external use
    window.BonditAudience = {
      get: getAudience,
      set: setAudience,
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gbx-button"] && !Shopify.designMode) return;
  try {
    (function () {
    function applyAudience(audience) {
      document.querySelectorAll('[data-audience-href]').forEach(function (el) {
        var url = audience === 'trade' ? el.dataset.tradeUrl : el.dataset.consumerUrl;
        if (url) el.setAttribute('href', url);
      });
    }

    function currentAudience() {
      if (window.themeSettings?.customerLoggedIn) return 'trade';
      return document.documentElement.dataset.audience || window.themeSettings?.defaultAudience || 'trade';
    }

    function init() {
      applyAudience(currentAudience());
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('audience:changed', function (event) {
      applyAudience(event.detail.audience);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lazy-video"] && !Shopify.designMode) return;
  try {
    (function () {
    var videos = document.querySelectorAll('video.js-lazy-video');
    if (!videos.length) return;

    if (window.matchMedia('(max-width: 768px)').matches) {
      videos.forEach(function (video) {
        video.querySelectorAll('source').forEach(function (s) {
          s.removeAttribute('src');
        });
        video.load();
        if (video.parentNode) video.parentNode.removeChild(video);
      });
      return;
    }

    function suspendVideo(video) {
      video.querySelectorAll('source').forEach(function (s) {
        if (s.src && !s.dataset.src) {
          s.dataset.src = s.src;
          s.removeAttribute('src');
        }
      });
      video.load();
    }

    function loadVideo(video) {
      if (video.dataset.lazyLoaded) return;
      video.dataset.lazyLoaded = '1';
      video.querySelectorAll('source').forEach(function (s) {
        if (s.dataset.src) s.src = s.dataset.src;
      });
      video.load();
      if (video.hasAttribute('autoplay')) {
        video.play().catch(function () {});
      }
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadVideo(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px' }
    );

    videos.forEach(function (video) {
      suspendVideo(video);
      observer.observe(video);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
